/**
 *
 * @package citrus.vuex
 */
import {Vuex} from 'ui.vue.vuex';
import {basket} from 'citrus.vuex.basket';

const store = Vuex.store({
	modules: {
		basket: basket
	}
});

export {store};
